import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { GigCardShell, Media, Price, Badge, Rating, SellerInfo, SellerLevel, Title, Username, CollectGig, Countdown } from '../shared';
import { getCurrency, adaptGigData, getGigAssets, getRisingTalentExpVariation } from '../utils';
import { Avatar } from '@fiverr/fit';
import '@fiverr/globals';
import translations from '../translations.en.json';

class GigCard extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            unmounting: false
        };

        i18n.add(translations);
    }

    isFooterReversed(abTests) {
        const avgMedVariations = [2, 3];

        return abTests && avgMedVariations.indexOf(abTests.AVG_MEDIAN_PRICE_2) > -1;
    }

    getBadges(showRisingTalentBadge) {
        const {
            is_featured,
            is_limited_edition,
            quality_choice,
            limited_edition_expires_at,
            is_available_now,
            seller_name,
            is_pro,
            gig_id
        } = this.props.gig;
        const badges = [];

        if (is_limited_edition) {
            badges.push(
                <Badge key={`${gig_id}_badge_limited`} type="limited"/>,
                <Countdown key={`${gig_id}_countdown`} deadline={limited_edition_expires_at}/>
            );
        } else if (showRisingTalentBadge) {
            badges.push(<Badge key={`${gig_id}_badge_talent`} type="talent"/>);
        } else if (is_featured) {
            badges.push(<Badge key={`${gig_id}_badge_featured`} type="featured"/>);
        } else if (quality_choice) {
            badges.push(<Badge key={`${gig_id}_badge_choice`} type="choice"/>);
        } else if (is_available_now) {
            badges.push(<Badge key={`${gig_id}_badge_now`} type="now" seller={seller_name}/>);
        }

        is_pro && badges.push(<Badge key={`${gig_id}_badge_pro`} type="pro"/>);

        return badges;
    }

    render() {
        const {
            user,
            updateCollections,
            gig,
            context
        } = this.props;
        const userId = user && user.userId || null,
            risingTalentExpVariation = getRisingTalentExpVariation(gig.type, context.abTests),
            shouldRenderRating = (gig.rating > 0 || gig.is_pro || risingTalentExpVariation === 3) && risingTalentExpVariation !== 2,
            limitDisplayedRatings = context.abTests && context.abTests.RATINGS_THRESHOLD_ONE_HUNDRED === 2,
            isLimitedEdition = gig.is_limited_edition;

        adaptGigData(gig, {context});

        return (
            <GigCardShell cardType="card" key={gig.gig_id} type="mp-gig-card" gigId={gig.gig_id} cachedSlug={gig.cached_slug} position={gig.pos}>
                <a key={`title-link-${gig.gig_id}`} href={gig.gig_url} className="js-gig-card-imp-data">
                    <Media key={`media-${gig.gig_id}`} assets={getGigAssets(gig)} gigId={gig.gig_id} userId={userId}/>
                </a>
                <div className="gig-card-caption">
                    <SellerInfo>
                        {gig.is_seller_online && <span className="is-online"></span>}
                        <Avatar src={gig.seller_img}/>
                        <Username name={gig.seller_name} url={gig.seller_url}/>
                        {!risingTalentExpVariation && <SellerLevel level={gig.seller_level} isPro={gig.is_pro} isLimitedEdition={isLimitedEdition}/>}
                    </SellerInfo>
                    <Title gigUrl={gig.gig_url} caption={gig.iwill_title} classes={shouldRenderRating || isLimitedEdition || risingTalentExpVariation === 2 ? '' : 'no-rating '}/>
                    {shouldRenderRating && !isLimitedEdition && <Rating score={gig.rating} votes={gig.rating_count} starSize={15} starCount={1} isPro={gig.is_pro} risingTalentExpVariation={risingTalentExpVariation === 3} limitDisplayedRatings={limitDisplayedRatings}/>}
                    {this.getBadges(risingTalentExpVariation === 2)}
                </div>
                <footer className={`gig-card-footer${this.isFooterReversed(context.abTests) ? ' reversed' : ''}`}>
                    <CollectGig gigId={gig.gig_id} sellerId={gig.seller_id} updateCollections={updateCollections} user={user} showCollMenu={true} icon="ficon ficon-bars"/>
                    <Price gigUrl={gig.gig_url}
                        price={getCurrency(gig.price_i, true)}
                        showStartingAt={gig.show_starting_at}
                        isLimitedEdition={isLimitedEdition}
                        averagePrice={gig.average_price && getCurrency(gig.average_price, true)}
                        medianPrice={gig.median_price && getCurrency(gig.median_price, true)}/>
                </footer>
            </GigCardShell>
        );
    }
}

GigCard.propTypes = {
    user: PropTypes.object,
    gig: PropTypes.object,
    context: PropTypes.shape({
        pageCtxId: PropTypes.string,
        refCtxId: PropTypes.string,
        abTests: PropTypes.object
    })
};

GigCard.defaultProps = {
    context: {}
};

export default GigCard;



// WEBPACK FOOTER //
// ./src/mp_gig_card/GigCard.js